import React, { useState, useEffect } from "react";
import { Container, Form, Button, Row, Col, Modal, ListGroup, Alert } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/LicenseVerification.css";

const LicenseVerification = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [userRole, setUserRole] = useState(null);

  const handleMemberLogin = () => {
    navigate('/member-login');
  };

  const handleEdcclogin = () => { 
    navigate('/edcc-login');
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  useEffect(() => {
    // Check user role when token is available
    if (tokenState) {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      setUserRole(user.rolename);
    }
  }, [tokenState]);

  const handleContinue = () => {
    if (agreedToTerms) {
        navigate('/license-verification-form');
    }
  };

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container license-verify-content-container">
          <section className="license-verify-section">
            <Container className="container-license-verify">
              <h2 className="text-center license-verify-heading mb-4">
                License Verification - Terms & Conditions
              </h2>

              {/* Show message for associate members */}
              {tokenState && userRole === "AssociateMember" && (
                <Alert variant="warning" className="mb-4">
                  <Alert.Heading>
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    Access Restricted
                  </Alert.Heading>
                  <p className="mb-0">
                    License Verification certificates are only available for Life Members. 
                    Please upgrade to Life Membership to access this service.
                  </p>
                </Alert>
              )}

              {/* Show message for non-logged in users */}
              {!tokenState && (
                <Alert variant="info" className="mb-4">
                  <Alert.Heading>
                    <i className="fas fa-info-circle me-2"></i>
                    Please Login to Continue
                  </Alert.Heading>
                  <p className="mb-0">
                    You need to be logged in as a Life Member to access License Verification services.
                  </p>
                </Alert>
              )}

              {/* Show terms and conditions for everyone, but restrict access based on role */}
              <Form>
                <ListGroup variant="flush" className="mb-4">
                  <ListGroup.Item className="border-0">
                    <strong>1.</strong> The License Verification/Professional Advancement is issued by AIOTA upon request to its active Life Members only.
                  </ListGroup.Item>
                  <ListGroup.Item className="border-0">
                    <strong>2.</strong> The fee for License Verification/Professional Advancement  is INR 14,160/- (inclusive of 18% GST).
                    <ul className="mt-2 mb-0">
                      <li>Payment must be made online only.</li>
                      <li>Demand Draft (DD) will not be accepted.</li>
                    </ul>
                  </ListGroup.Item>
                  <ListGroup.Item className="border-0">
                    <strong>3.</strong> Upon request, AIOTA issues a License Verification Certificate after verifying the applicant's Life Membership status and ACOT/IOTR certificates.
                    <ul className="mt-2 mb-0">
                      <li>The certificate will be issued only in soft copy format.</li>
                      <li>Based on the applicant's request, the certificate will be sent either to the member or directly to the concerned regulatory body.</li>
                      <li>The applicant must clearly provide the email address or postal address where the certificate needs to be sent.</li>
                      <li>The validity of the Good Standing Certificate is 1 year from the date of issue.</li>
                    </ul>
                  </ListGroup.Item>
                  <ListGroup.Item className="border-0">
                    <strong>4.</strong> Any verification forms (e.g., NBCOT or similar regulatory authority forms) must be fully filled and submitted by the applicant.
                    <ul className="mt-2 mb-0">
                      <li>AIOTA shall not be responsible for the accuracy of the details filled in such forms.</li>
                    </ul>
                  </ListGroup.Item>
                  <ListGroup.Item className="border-0">
                    <strong>5.</strong> The Life Membership Number of the applicant is mandatory to complete the License Verification process.
                    <ul className="mt-2 mb-0">
                      <li>ACOT number alone will not be accepted.</li>
                      <li>Submission of copies of Life Membership Certificate and ACOT/IOTR certificates is mandatory.</li>
                    </ul>
                  </ListGroup.Item>
                  <ListGroup.Item className="border-0">
                    <strong>6.</strong> The License Verification process typically takes 10 to 14 working days from the date of successful payment.
                  </ListGroup.Item>
                  <ListGroup.Item className="border-0">
                    <strong>7.</strong> The applicant must carefully cross-check and confirm that all information entered in the application form is accurate, complete, and up to date.
                  </ListGroup.Item>
                  <ListGroup.Item className="border-0">
                    <strong>8.</strong> AIOTA will issue certificates strictly based on the information provided by the applicant in the submitted application and supporting documents.
                  </ListGroup.Item>
                  <ListGroup.Item className="border-0">
                    <strong>9.</strong> AIOTA shall not be held responsible for any incorrect, incomplete, or inaccurate information submitted by the applicant and will not reissue certificates in cases of data entry errors or incorrect submissions.
                  </ListGroup.Item>
                  <ListGroup.Item className="border-0">
                    <strong>10.</strong> To apply for a License Verification / Good Standing Certificate, you must be a member of AIOTA for at least 6 months.
                  </ListGroup.Item>
                </ListGroup>

                {/* Show checkbox and buttons only for Life Members */}
                {tokenState && userRole === "LifeMember" && (
                  <>
                    <Form.Check
                      type="checkbox"
                      id="termsCheckbox"
                      label="I have read and agree to the Terms and Conditions"
                      checked={agreedToTerms}
                      onChange={(e) => setAgreedToTerms(e.target.checked)}
                      className="mb-3"
                    />

                    <Row className="d-flex justify-content-center gap-3">
                        <Button
                            variant="secondary"
                            className="w-auto"
                            onClick={() => navigate(-1)}
                            >
                            Not Right Now
                        </Button>
                        <Button
                            variant="primary"
                            className="w-auto"
                            onClick={handleContinue}
                            disabled={!agreedToTerms}
                            >
                            Continue
                        </Button>
                    </Row>
                  </>
                )}

                {/* Show buttons for non-life members */}
                {(tokenState && userRole === "AssociateMember") || !tokenState ? (
                  <Row className="d-flex justify-content-center gap-3">
                    <Button
                      variant="secondary"
                      className="w-auto"
                      onClick={() => navigate(-1)}
                    >
                      Go Back
                    </Button>
                    {!tokenState && (
                      <Button
                        variant="primary"
                        className="w-auto"
                        onClick={handleMemberLogin}
                      >
                        Login as Life Member
                      </Button>
                    )}
                  </Row>
                ) : null}
              </Form>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default LicenseVerification;